import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EditSolicitudExPcfViewModel, SolicitudExItemResultsViewModel, SolicitudExItemViewModel, SolicitudExViewModel } from './solicitudesex.types';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ResetFiltersService } from 'src/app/components/core/_infrastructure/classes/services/reset-filters.service';

@Injectable()
export class SolicitudExService extends ResetFiltersService {
    solicitudExEndpoint = this.baseUrl + 'api/mantenimiento/solicitudEx/';
    public currentFilterSolicitudEx = new SolicitudExItemViewModel();
    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    getSolicitudExPagedByFilter(params: HttpParams): Observable<SolicitudExItemResultsViewModel> {
        return this.http.get<SolicitudExItemResultsViewModel>(this.solicitudExEndpoint + 'PagedByFilter/', { params: params });
    }

    getSolicitudEx(id: number): Observable<SolicitudExItemViewModel> {
        return this.http.get<SolicitudExItemViewModel>(this.solicitudExEndpoint + id);
    }
    private editSolicitudEx(solicitudEx: SolicitudExViewModel): Observable<any> {
        return this.http.put<SolicitudExViewModel>(this.solicitudExEndpoint, solicitudEx);
    }

    saveSolicitudEx(solicitudEx: SolicitudExViewModel): Observable<any> {
        return this.editSolicitudEx(solicitudEx);
    }

    saveSolicitudExPcf(model: EditSolicitudExPcfViewModel): Observable<any> {
        return this.editSolicitudExPcf(model);
    }

    private editSolicitudExPcf(model: EditSolicitudExPcfViewModel): Observable<any> {
        return this.http.put<EditSolicitudExPcfViewModel>(this.baseUrl + 'api/exportacion/inspeccionesEx/EditSolicitudExParaReasignacionPcf', model);
    }


    resetFilter() {
        this.currentFilterSolicitudEx = new SolicitudExItemViewModel();
    }
}
